import { Component, OnInit, ViewChild } from '@angular/core';
import { MensagemService, RestricaoOperador, Restricoes, Restricao, ConsultaPaginada } from 'maestro-ng';
import { SelectItem } from 'primeng/api';
import { VirtualScroller } from 'primeng/virtualscroller';
import { PeticaoInicialFiltro } from '../../models/peticao-inicial-filtro.enum ';
import { SelectItemService } from '../../services/select-item.service';

import { Processo } from '../processo.model';
import { ProcessoService } from '../processo.service';
import { ProcessoDocumento } from './../../processo-documento/processo-documento.model';

@Component({
  selector: 'app-processo-lista',
  templateUrl: './processo-lista.component.html',
  styleUrls: ['./processo-lista.component.css'],
})
export class ProcessoListaComponent implements OnInit {
  public quantidadeRegistros = 20;
  public processos: Processo[];
  public carregandoProcessos: boolean;
  public restricoes: Restricoes;
  public error = false;
  public peticaoInicialFiltroItens: SelectItem[];
  public peticaoInicialFiltro: PeticaoInicialFiltro;

  @ViewChild('vsProcessos')
  public vs: VirtualScroller;
  public numeroProcesso: any;

  constructor(
    private service: ProcessoService,
    private mensagemService: MensagemService,
    private selectItemService: SelectItemService
  ) {
    this.peticaoInicialFiltro = PeticaoInicialFiltro.TODOS;
    this.peticaoInicialFiltroItens = this.selectItemService.getFiltroPeticaoInicial();
    this.restricoes = new Restricoes([
      new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'fonteDados.nome', operador: RestricaoOperador.START_WITH }),
      new Restricao<string>({ atributo: 'origemId', operador: RestricaoOperador.EQUALS }),
      new Restricao<string>({ atributo: 'numeroProcesso', operador: RestricaoOperador.START_WITH }),
    ]);
  }

  ngOnInit(): void {}

  public onEnterPesquisar(event): void {
    if (event.keyCode === 13) {
      this.pesquisar();
    }
  }

  public pesquisar(): void {
    const primeiroCarregamento = this.processos === undefined;
    this.processos = Array.from({ length: this.quantidadeRegistros * 2 });
    if (this.vs !== undefined) {
      this.vs.scrollToIndex(0);
    }
    if (!primeiroCarregamento) {
      this.onLazyLoad(0);
    }
  }

  public onLazyLoad(firstResult: number): void {
    this.carregarProcessos(firstResult);
  }

  private carregarProcessos(firstResult?: number): void {
    this.carregandoProcessos = true;
    this.error = false;

    const consulta = new ConsultaPaginada();
    consulta.inicio = firstResult || 0;
    consulta.limite = this.quantidadeRegistros;
    consulta.restricoes = this.restricoes.getAtivas();
    consulta.contabilizar = false;

    const restrictionNumProcesso = this.restricoes.atributo('numeroProcesso');

    if (restrictionNumProcesso && restrictionNumProcesso.valor) {
      const ehNumCompleto = restrictionNumProcesso.valor.replace(/\D/g, '').length === 20;
      if (ehNumCompleto) {
        restrictionNumProcesso.operador = RestricaoOperador.EQUALS;
      } else {
        restrictionNumProcesso.operador = RestricaoOperador.START_WITH;
      }
    }

    if (this.peticaoInicialFiltro === PeticaoInicialFiltro.COM_PETICAO_INICIAL) {
      consulta.restricoes.push(
        new Restricao<ProcessoDocumento>({ atributo: 'peticaoInicial', operador: RestricaoOperador.IS_NOT_NULL })
      );
    } else if (this.peticaoInicialFiltro === PeticaoInicialFiltro.SEM_PETICAO_INICIAL) {
      consulta.restricoes.push(
        new Restricao<ProcessoDocumento>({ atributo: 'peticaoInicial', operador: RestricaoOperador.IS_NULL })
      );
    }

    this.service
      .recuperarPaginado(consulta)
      .then((resultado) => {
        const carregados = this.processos.filter((item) => item !== undefined);

        if (resultado.entidades.length === 0) {
          this.processos = carregados;
        } else if (resultado.entidades.length < this.quantidadeRegistros) {
          this.processos = carregados.concat(resultado.entidades);
        } else {
          this.processos = carregados.concat(resultado.entidades).concat(Array.from({ length: this.quantidadeRegistros * 2 }));
        }

        this.carregandoProcessos = false;
      })
      .catch((response) => {
        this.carregandoProcessos = false;
        this.error = true;
        this.mensagemService.addErro('Erro ao carregar os dados da pesquisa!', response.error);
      });
  }

  public limpar() {
    this.peticaoInicialFiltro = PeticaoInicialFiltro.TODOS;
    this.peticaoInicialFiltroItens = this.selectItemService.getFiltroPeticaoInicial();
    this.processos = undefined;
    this.restricoes.limpar();
  }
}
